<template>
    <div class="col-md-9">
        <h1 class="pages__title">Pages</h1>
        <div class="pages__table">
            <div class="pages__top">
                <div class="num">
                    #
                </div>
                <div class="title-page">
                    Title
                </div>
                <div class="route">
                    Route
                </div>
                <div class="action">
                    Action
                </div>
            </div>
            <ul class="pages__list">
                <li
                    class="pages__line"
                    v-for="(page, index) in listOfPages"
                    :key="page.id"
                >
                    <div class="num">
                        {{ index +1 }}
                    </div>
                    <div class="title-page">
                        {{ page.title}}
                    </div>
                    <div class="route">
                        {{ page.route }}
                    </div>
                    <div class="action">
                        <div class="action__hold">
                            <a
                                :href="`/admin/panel/pages/${page.id}/edit`"
                                area-label="Edit Item"
                                class="edit"
                            >
                                <svg width="16" height="16" aria-hidden="true">
                                    <use href="/img/svg/symbol-defs.svg#icon-edit"></use>
                                </svg>
                            </a>
                            <a
                                href="javascript:void(0)"
                                area-label="Remove Item"
                                class="delete"
                                @click="openDeleteModal(page.id)"
                            >
                                <svg width="16" height="16" aria-hidden="true">
                                    <use href="/img/svg/symbol-defs.svg#icon-close-9"></use>
                                </svg>
                            </a>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <ActionModal
            :modal-id="getCustomModalId('delete',currentPageId)"
            @confirm="deletePage(currentPageId)"
            :reject-text="`No`"
            :confirm-text="`Yes`"
        >
            <template #body>
                <div class="text-center mb-4">
                    <div class="text-center">
                        <h5 class="title">Are you sure ?</h5>
                        <p>Do you want to delete this page?</p>
                    </div>
                </div>
            </template>
        </ActionModal>
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import AdminPanelService from "../../../services/AdminPanelService";
import ModalHandler from "../../../mixins/ModalHandler";
import ActionModal from "../../Common/ActionModal.vue";

export default defineComponent({
    name: "Pages.vue",
    components: {ActionModal},
    mixins: [ModalHandler],
    data() {
        return {
            listOfPages: [],
            currentPageId: null,
        }
    },
    methods: {
        async fetchListOfPages() {
            try {
                const { data: response } = await AdminPanelService.fetchListOfPages()
                this.listOfPages = response

            } catch (e) {
                console.error(e)
            }
        },
        openDeleteModal(id) {
            this.currentPageId = id
            this.$nextTick(()=> {
                this.showCustomModal('delete', id)
            })
        },
        async deletePage(pageId) {
            try {
                await AdminPanelService.deletePage(pageId)
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('The Page was not deleted. Please try again')
            }
        }
    },
    mounted() {
        this.fetchListOfPages()
    }
})
</script>



<style scoped>

</style>
